/*eslint-disable react/jsx-no-target-blank */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import './footer.scss';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import APIEndpoints from '../../api/APIEndpoints';
import { axiosInstance } from '../../../../src/api/axios';
import { arrayBufferToBase64 } from '../../utils/common';
import downloadTypes from '../../../../src/common/downloadTypes.json';

function ListItem(props) {
  //Correct! There is no need to specify the key here:
  return <li>{props.value}</li>;
}

export default function Links({ blockId }) {
  const dispatch = useDispatch();
  const { isLinksLoaded, linksInfo } = useSelector((state) => state.footer);
  let block = [];

  if (linksInfo && Object.keys(linksInfo).length > 0) {
    block = linksInfo.filter((link) => link.BlockNumber == blockId);
    block.sort((a, b) => (a.LinkTitle > b.LinkTitle ? 1 : -1));
  }

  const downloadFile = async (parameter, fileName, e) => {
    const documentData = await axiosInstance.get(
      APIEndpoints.getDocument() + parameter,
      { responseType: 'arraybuffer' },
    );
    const contentType = documentData.headers['content-type'];
    const extensionarr = downloadTypes.filter(
      (d) => d.contentType === contentType?.toLowerCase(),
    );
    let extension = '.pdf';
    fileName = fileName ? fileName : 'download';
    if (extensionarr && extensionarr?.length) {
      extension = extensionarr[0].extension;
    }

    if (extension === '.pdf') {
      const binaryData = [];
      binaryData.push(documentData.data);
      const fileURL = window.URL.createObjectURL(
        new Blob(binaryData, { type: 'application/pdf' }),
      );
      window.open(fileURL);
    } else {
      const actualData = arrayBufferToBase64(documentData.data);
      const link = document.createElement('a');
      link.setAttribute(
        'href',
        'data:' + contentType + ';base64,' + actualData,
      );
      link.setAttribute('download', fileName + extension);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    //function openBase64NewTab(base64Pdf: string): void {
    //var blob = base64toBlob(base64Pdf);
    //if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //window.navigator.msSaveOrOpenBlob(blob, "pdfBase64.pdf");
    //} else {
    //const blobUrl = URL.createObjectURL(blob);
    //window.open(blobUrl);
    //}
    //}

    //function base64toBlob(base64Data: string) {
    //const sliceSize = 1024;
    //const byteCharacters = atob(base64Data);
    //const bytesLength = byteCharacters.length;
    //const slicesCount = Math.ceil(bytesLength / sliceSize);
    //const byteArrays = new Array(slicesCount);

    //for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    //const begin = sliceIndex * sliceSize;
    //const end = Math.min(begin + sliceSize, bytesLength);

    //const bytes = new Array(end - begin);
    //for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
    //bytes[i] = byteCharacters[offset].charCodeAt(0);
    //}
    //byteArrays[sliceIndex] = new Uint8Array(bytes);
    //}
    //return new Blob(byteArrays, { type: "application/pdf" });
    //}
    //openBase64NewTab(actualData);
  };

  return (
    <>
      {block.length > 0 && (
        <>
          <Col md={6} lg={6} sm={6} xs={6}>
            <h3>{block[0].BlockTitle}</h3>
            <ul className="footer-block">
              {isLinksLoaded && block.length > 0 && (
                <>
                  {block.map((link) => (
                    <React.Fragment key={link.OID}>
                      {link.LinkType === 'External' && (
                        <li>
                          <a href={link.ExternalUrl} target="_blank">
                            {link?.LinkTitle.charAt(0).toUpperCase() +
                              link?.LinkTitle.slice(1)}
                          </a>
                        </li>
                      )}
                      {link.LinkType === 'Page' && (
                        <li>
                          <>
                            {link.ContentReference === 'External' && (
                              <Link
                                target={'_blank'}
                                to={{
                                  pathname: `/member/page/${link.Slug}`,
                                }}
                                state={{ OID: link.PageOID, newTab: true }}
                              >
                                {link?.LinkTitle.charAt(0).toUpperCase() +
                                  link?.LinkTitle.slice(1)}
                              </Link>
                            )}
                            {link.ContentReference === 'Internal' && (
                              <Link
                                to={{
                                  pathname: `/member/page/${link.Slug}`,
                                }}
                                state={{ OID: link.PageOID }}
                              >
                                {link?.LinkTitle.charAt(0).toUpperCase() +
                                  link?.LinkTitle.slice(1)}
                              </Link>
                            )}
                          </>
                        </li>
                      )}
                      {link.LinkType === 'Document' && (
                        <li>
                          <Link
                            to={{
                              pathname: `/member/document/${link.Slug}`,
                            }}
                          >
                            {link?.LinkTitle.charAt(0).toUpperCase() +
                              link?.LinkTitle.slice(1)}
                          </Link>
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </>
              )}
            </ul>
          </Col>
        </>
      )}
    </>
  );
}
